import { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { toast } from "react-toastify";

export default function useTableDialog({
  show,
  restaurantId,
  preSelectedTable,
  selectOk,
  onHide,
  setParentSelectedTable,
  SetselecteOk,
}) {
  const [tableInfos, setTableInfos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTable, setSelectedTable] = useState(null);
  const [pendingTable, setPendingTable] = useState(null);
  const [hideAvailableTables, setHideAvailableTables] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(0);

  const infoContainerRef = useRef(null);
  const topSectionRef = useRef(null);
  const bottomContainerRef = useRef(null);

  const apiAddress = process.env.REACT_APP_SECRET;

  // --- Fetch tables ---
  useEffect(() => {
    if (!show) return;
    setLoading(true);
    axios
      .get(
        `${apiAddress}/api/RestaurantTable/GetAllRestaurantTableInfosByRestaurantId?restaurantId=${restaurantId}`
      )
      .then((res) => {
        const tables = res.data;
        setTableInfos(tables);
        const selected = tables.find(
          (t) => t.tableId === preSelectedTable?.tableId
        );
        setSelectedTable(selected || null);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching tables:", err);
        setLoading(false);
      });
  }, [show, restaurantId, selectOk]);

  // --- Handle search ---
  const handleSearchChange = (e) => setSearchQuery(e.target.value);

  const filteredTables = tableInfos.filter((table) =>
    table.tableName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleScroll = useCallback(() => {
    if (!bottomContainerRef.current) return;
    const currentScrollPos = bottomContainerRef.current.scrollTop;

    // Show when scrolling up, hide when scrolling down
    if (currentScrollPos < prevScrollPos) {
      // Scrolling up - show immediately
      setHideAvailableTables(false);
    } else if (currentScrollPos > prevScrollPos && currentScrollPos > 10) {
      // Scrolling down - hide immediately
      setHideAvailableTables(true);
    }

    setPrevScrollPos(currentScrollPos);
  }, [prevScrollPos]);

  useEffect(() => {
    const bottomContainer = bottomContainerRef.current;
    if (bottomContainer)
      bottomContainer.addEventListener("scroll", handleScroll);
    return () => bottomContainer?.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  // --- Select pending ---
  const handletable = (table) => setPendingTable(table);

  useEffect(() => {
    if (preSelectedTable) {
      setSelectedTable(preSelectedTable);
      setParentSelectedTable(preSelectedTable);
      setPendingTable(preSelectedTable);
    }
  }, [preSelectedTable]);

  // --- Confirm table selection ---
  const handleCardClick = async (table) => {
    SetselecteOk((prev) => [...prev, table]);
    const token = localStorage.getItem("gotasteClienttoken");
    const decoded = jwtDecode(token);
    try {
      const res = await axios.patch(
        `${apiAddress}/api/Cart/UpdateCartTableDetails?customerId=${decoded.UserId}&TableId=${table.tableId}&TableName=${table.tableName}&RestaurantId=${restaurantId}`
      );
      if (res.data) {
        toast.success(res.data);
        onHide();
      }
    } catch (error) {
      console.error(error);
    }
  };

  // --- Sort tables ---
  const sortedTableInfos = filteredTables.sort((a, b) => {
    if (selectOk && a.tableId === selectOk.tableId) return -1;
    if (selectOk && b.tableId === selectOk.tableId) return 1;
    if (selectedTable && a.tableId === selectedTable.tableId) return -1;
    if (selectedTable && b.tableId === selectedTable.tableId) return 1;
    return 0;
  });

  return {
    tableInfos,
    loading,
    searchQuery,
    selectedTable,
    pendingTable,
    hideAvailableTables,
    infoContainerRef,
    topSectionRef,
    bottomContainerRef,
    setSelectedTable,
    setParentSelectedTable,
    handleSearchChange,
    handleCardClick,
    handletable,
    sortedTableInfos,
    handleScroll,
    setPendingTable,
  };
}
